import { DocumentOpener } from '@/data/protocols/document-opener'

export class BrowserDocumentOpener implements DocumentOpener {
  async open (getUrl: () => Promise<string>): Promise<void> {
    const tab = window.open('about:blank', '_blank')

    if (!tab) {
      throw new Error('Não foi possível abrir a guia do documento. Tente novamente.')
    }

    try {
      tab.opener = null
      tab.document.title = 'Documento'
      tab.document.body.textContent = 'Carregando documento. Aguarde...'

      const url = await getUrl()

      if (tab.closed) {
        throw new Error('A guia do documento foi fechada. Tente novamente.')
      }

      tab.location.replace(url)
    } catch (error) {
      tab.close()
      throw error
    }
  }
}
